import { SetObjectAccessorPropertyHelperBase } from './SetObjectAccessorPropertyHelperBase';
export class SetAccessorPropertyObjectPropertyHelper extends SetObjectAccessorPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getPropertyObject;
    }
}

//# sourceMappingURL=SetAccessorPropertyObjectPropertyHelper.js.map
